module.exports = __webpack_public_path__ + "img/kjrc-kyzlzp.a0d63441.jpg";